export default __webpack_public_path__ + "static/media/Fictiv.acdf4d74.png";